import { HEADER_HEIGHT } from '../../../../../constants';
import { FORTA_BLUE, FORTA_GRAY9, FORTA_WHITE } from '../../../../../utils/colors';

import type { SxProps, Theme } from '@mui/material/styles';

export const PAGE_HEADER_ROOT_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '24px',
  height: HEADER_HEIGHT,
  px: '24px',
  boxSizing: 'border-box',
  backgroundColor: FORTA_BLUE.medium,
  position: 'relative',
  zIndex: 9,
};

export const PAGE_HEADER_TITLE_BLOCK_SX: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  flexShrink: 0,
  minWidth: 208,
};

export const PAGE_HEADER_TITLE_SX: SxProps<Theme> = {
  fontFamily: 'DMSansBold',
  fontSize: 24,
  lineHeight: '38px',
  letterSpacing: '1px',
  color: FORTA_WHITE,
  whiteSpace: 'nowrap',
};

export const PAGE_HEADER_AUTHOR_SX: SxProps<Theme> = {
  fontFamily: 'DMSansRegular',
  fontSize: 16,
  lineHeight: '31px',
  letterSpacing: '1px',
  color: FORTA_WHITE,
  whiteSpace: 'nowrap',
};

export const PAGE_HEADER_TAGS_SX: SxProps<Theme> = {
  display: { xs: 'none', md: 'flex' },
  flex: 1,
  minWidth: 0,
  alignItems: 'center',
  justifyContent: 'center',
  gap: '24px',
};

export const PAGE_HEADER_TAG_SX: SxProps<Theme> = {
  position: 'relative',
  width: 140,
  height: 44,
  flexShrink: 0,
};

export const PAGE_HEADER_TAG_FRAME_SX: SxProps<Theme> = {
  position: 'absolute',
  top: 8,
  left: 0,
  right: 0,
  bottom: 0,
  border: `2px solid ${FORTA_WHITE}`,
  borderRadius: '10px',
  boxSizing: 'border-box',
};

export const PAGE_HEADER_TAG_LABEL_SX: SxProps<Theme> = {
  position: 'absolute',
  top: 0,
  left: 15,
  px: '6px',
  backgroundColor: FORTA_WHITE,
  borderRadius: '8px',
  fontFamily: 'DMSansMedium',
  fontSize: 13,
  lineHeight: '16px',
  color: FORTA_GRAY9,
  whiteSpace: 'nowrap',
};

export const PAGE_HEADER_TAG_VALUE_SX: SxProps<Theme> = {
  position: 'absolute',
  top: 17,
  left: 9,
  right: 8,
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontFamily: 'DMSansRegular',
  fontSize: 14,
  lineHeight: '16px',
  color: FORTA_WHITE,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
};

export const PAGE_HEADER_TAG_VALUE_CENTERED_SX: SxProps<Theme> = {
  position: 'absolute',
  top: 17,
  left: 9,
  right: 8,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: 'DMSansRegular',
  fontSize: 14,
  lineHeight: '16px',
  color: FORTA_WHITE,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
};

export const PAGE_HEADER_TAG_DOT_SX: SxProps<Theme> = {
  width: 18,
  height: 18,
  borderRadius: '50%',
  flexShrink: 0,
};

export const PAGE_HEADER_ACTIONS_SX: SxProps<Theme> = {
  ml: { xs: 'auto', md: 0 },
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
};
